module.exports = __webpack_public_path__ + "img/paiement-en-especes.cf208ea0.png";